/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AICategoryMiniReference
 */
export interface AICategoryMiniReference {
    /**
     * 
     * @type {string}
     * @memberof AICategoryMiniReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AICategoryMiniReference
     */
    readonly name?: string;
}

export function AICategoryMiniReferenceFromJSON(json: any): AICategoryMiniReference {
    return AICategoryMiniReferenceFromJSONTyped(json, false);
}

export function AICategoryMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AICategoryMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function AICategoryMiniReferenceToJSON(value?: AICategoryMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


